export default __webpack_public_path__ + "static/media/twitter_logo_white.d7beecf1.svg";